import React from "react";
import Select from "./ui/Select";
import DatePicker from "./ui/DatePicker";
import Button from "./ui/Button";
import MultiSelectDropdown from "./ui/MultiSelectDropdown";
import ExportButtonGroup from "./ui/ExportButtonGroup";

const TYPE_OPTIONS = [
  { value: "sve", label: "Objedinjeno" },
  { value: "prodaja", label: "Prodaja" },
  { value: "rashod", label: "Rashod" },
];

/**
 * Filter bar (Warehouse / Type / From / To) + export buttons.
 * Used by Dashboard.js and ReportTable.js, two pages that used to have
 * an identical set of filters, each with its own hand-written code.
 */
export default function FilterBar({
  type,
  setType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  selectedWarehouses,
  setSelectedWarehouses,
  warehouses,
  onApply,
  onExportExcel,
  onExportPdf,
  onExportPrint,
  exportDisabled,
}) {
  const showExport = Boolean(onExportExcel || onExportPdf || onExportPrint);

  return (
    <div className="flex flex-wrap items-end gap-x-3 gap-y-3 rounded-xl border border-slate-200 bg-surface p-3 dark:border-slate-800 dark:bg-slate-900">
      {type !== undefined && (
        <Select label="Tip" value={type} onChange={(e) => setType(e.target.value)} options={TYPE_OPTIONS} />
      )}
      <DatePicker label="Od" value={startDate} onChange={setStartDate} />
      <DatePicker label="Do" value={endDate} onChange={setEndDate} />
      <MultiSelectDropdown
        label="Magacin"
        options={warehouses.map((w) => ({ value: w.id, label: w.name }))}
        selected={selectedWarehouses}
        onChange={setSelectedWarehouses}
      />
      {onApply && <Button onClick={onApply}>Prikaži</Button>}
      {showExport && (
        <div className="w-full border-t border-slate-100 pt-3 dark:border-slate-800 sm:ml-auto sm:w-auto sm:border-0 sm:pt-0">
          <ExportButtonGroup
            onExcel={onExportExcel}
            onPdf={onExportPdf}
            onPrint={onExportPrint}
            disabled={exportDisabled}
          />
        </div>
      )}
    </div>
  );
}
